import React, { useState, useEffect, useRef } from "react";
import api from "../../api";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Select from "react-select";
import { FaSearch, FaFilePdf, FaCog } from "react-icons/fa";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

const StudentMarksheetListPage = () => {
  const [form, setForm] = useState({
    exam_id: "",
    class_id: "",
    section_id: "",
  });
  const [showPreviousResult, setShowPreviousResult] = useState(false);
  const [showWrittenOral, setShowWrittenOral] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const settingsRef = useRef(null);
  const [exams, setExams] = useState([]);
  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [marksheets, setMarksheets] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🟩 Toast Function
  const showToast = (type, message) => {
    const options = {
      position: "top-right",
      autoClose: 2000,
      theme: "colored",
      pauseOnHover: true,
    };
    switch (type) {
      case "success":
        toast.success(message, options);
        break;
      case "error":
        toast.error(message, options);
        break;
      case "warning":
        toast.warning(message, options);
        break;
      default:
        toast.info(message, options);
    }
  };

  // 🟦 Initial Fetch
  useEffect(() => {
    fetchExams();
    fetchClasses();
  }, []);

  // Close settings dropdown when clicking outside it.
  useEffect(() => {
    const handleDocumentMouseDown = (event) => {
      if (settingsRef.current && !settingsRef.current.contains(event.target)) {
        setShowSettings(false);
      }
    };

    document.addEventListener("mousedown", handleDocumentMouseDown);
    return () => {
      document.removeEventListener("mousedown", handleDocumentMouseDown);
    };
  }, []);

  // 🟦 Fetch Exams
  const fetchExams = async () => {
    try {
      const res = await api.get("/exam-management/list");
      if (res.data?.status && res.data.data.length) {
        setExams(res.data.data);
        showToast("success", "Exams loaded successfully!");
      } else {
        setExams([]);
        showToast("warning", "No exams found!");
      }
    } catch {
      showToast("error", "Failed to load exams");
    }
  };

  // 🟦 Fetch Classes
  const fetchClasses = async () => {
    try {
      const res = await api.get("/get-classes");
      if (res.data?.success && res.data.data.length) {
        setClasses(res.data.data);
        showToast("success", "Classes loaded successfully!");
      } else {
        setClasses([]);
        showToast("warning", "No classes found!");
      }
    } catch {
      showToast("error", "Failed to load classes");
    }
  };

  // 🟦 Fetch Sections
  const fetchSections = async (classId) => {
    try {
      const res = await api.get(`/get-sections/${classId}`);
      if (res.data?.success && res.data.data.length) {
        setSections(res.data.data);
        showToast("success", "Sections loaded!");
      } else {
        setSections([]);
        showToast("warning", "No sections found!");
      }
    } catch {
      setSections([]);
      showToast("error", "Failed to load sections");
    }
  };

  // 🟩 Handle Input Change
  const handleChange = (field, value) => {
    setForm({ ...form, [field]: value });

    // Exam change korle Previous Result OFF
    if (field === "exam_id") {
      setShowPreviousResult(false);
    }

    if (field === "class_id" && value) {
      fetchSections(value.id);
      setForm({
        ...form,
        class_id: value,
        section_id: "",
      });
    }
  };

  // 🟦 Fetch Marksheet List
  const handleSearch = async () => {
    if (!form.exam_id || !form.class_id || !form.section_id) {
      showToast("error", "Please select all filters!");
      return;
    }

    setLoading(true);
    try {
      const res = await api.get("/student/mark-sheet/list", {
        params: {
          exam_id: form.exam_id.id,
          class_id: form.class_id.id,
          section_id: form.section_id.id,
        },
      });

      if (res.data?.success && res.data.data.length) {
        setMarksheets(res.data.data);
        showToast("success", "Marksheet list loaded successfully!");
      } else {
        setMarksheets([]);
        showToast("warning", "No marksheet found!");
      }
    } catch {
      showToast("error", "Failed to fetch marksheet list!");
    } finally {
      setLoading(false);
    }
  };

  //   const generateMarksheet = async (student_id, exam_id) => {
  //   try {
  //     const res = await api.get(`/student/mark-sheet/view/${student_id}/${exam_id}`);
  //     if (!res.data?.success) {
  //       showToast("error", "Failed to generate marksheet!");
  //       return;
  //     }

  //     const data = res.data.data;

  //     // SCHOOL LOGO FIX
  //     const schoolLogo = data.school.logo
  //       ? `https://dgps.co.in/public/admin/assets/img/schools/logo/${data.school.logo}`
  //       : "https://dgps.co.in/public/admin/assets/img/logo.png";

  //     const studentPhoto =
  //       data.student.file && data.student.file !== ""
  //         ? data.student.file
  //         : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";

  //     // ✔ FIXED MARK TYPE HEADER GENERATOR
  //     const markTypeHeaders = (() => {

  //       // main + extra সব subject একত্র করলাম
  //       const allSubjects = [...data.subjects.main, ...data.subjects.extra];

  //       const allItems = allSubjects.flatMap((s) => s.items || []);
  //       const uniqueTypes = [];

  //       allItems.forEach((i) => {
  //         if (!uniqueTypes.find((u) => u.mark_type_id === i.mark_type_id)) {
  //           uniqueTypes.push({
  //             mark_type_id: i.mark_type_id,
  //             title: i.title || "Type",
  //           });
  //         }
  //       });

  //       return uniqueTypes;
  //     })();

  //     // PRINT WINDOW START
  //     const printWin = window.open("", "_blank");

  //     printWin.document.write(`
  //       <html>
  //       <head>
  //         <title>Marksheet - ${data.student.name}</title>

  //         <style>
  //           @page {
  //             size: A4 portrait;
  //             margin: 10mm;
  //           }

  //           body {
  //             font-family: "Poppins", Arial, sans-serif;
  //             background: #f8faff;
  //             margin: 0;
  //           }

  //           .border {
  //             border: 10px double #0056d6;
  //             padding: 25px 35px;
  //             background: #fff;
  //             border-radius: 8px;
  //             max-width: 800px;
  //             margin: auto;
  //           }

  //           .school-header {
  //             display: flex;
  //             align-items: center;
  //             justify-content: space-between;
  //             border-bottom: 2px solid #0056d6;
  //             padding-bottom: 10px;
  //             margin-bottom: 15px;
  //           }

  //           .school-logo {
  //             width: 90px;
  //             height: 90px;
  //             object-fit: contain;
  //           }

  //           .school-name {
  //             font-size: 24px;
  //             font-weight: 800;
  //             color: #003a80;
  //             text-transform: uppercase;
  //             text-align: center;
  //           }

  //           .school-contact {
  //             font-size: 12px;
  //             text-align: center;
  //             color: #555;
  //           }

  //           .certificate {
  //             text-align: center;
  //             text-decoration: underline;
  //             color: #00723e;
  //             font-weight: 700;
  //             margin-top: 4px;
  //           }

  //           .exam-title {
  //             text-align: center;
  //             font-size: 14px;
  //             font-weight: 700;
  //             margin-top: 3px;
  //           }

  //           .student-box {
  //             border: 1px solid #0056d6;
  //             padding: 12px;
  //             background: #f9fbff;
  //             border-radius: 6px;
  //             display: grid;
  //             grid-template-columns: 1fr 130px;
  //             gap: 20px;
  //             margin-bottom: 20px;
  //           }

  //           .info-table td {
  //             padding: 6px;
  //             font-size: 13px;
  //             border-bottom: 1px dashed #999;
  //           }

  //           .info-table td:first-child {
  //             font-weight: 600;
  //           }

  //           .photo-box {
  //             width: 130px;
  //             height: 150px;
  //             border: 2px solid #007bff;
  //             border-radius: 8px;
  //             overflow: hidden;
  //           }

  //           .marks-table th {
  //             background: #d7e9ff;
  //             border: 1px solid #0056d6;
  //             padding: 8px;
  //             font-size: 13px;
  //           }

  //           .marks-table td {
  //             border: 1px solid #9dbdfc;
  //             padding: 6px;
  //             font-size: 13px;
  //             text-align: center;
  //           }

  //           .summary-title {
  //             background: #dce8ff;
  //             border: 1px solid #0056d6;
  //             padding: 6px;
  //             margin-top: 25px;
  //             font-weight: 700;
  //             text-align: center;
  //           }

  //           .summary-table td {
  //             border: 1px solid #9dbdfc;
  //             padding: 6px;
  //             text-align: center;
  //           }

  //           .footer {
  //             display: flex;
  //             justify-content: space-between;
  //             margin-top: 40px;
  //             font-weight: 600;
  //           }

  //           .result-tag {
  //             margin-top: 20px;
  //             background: linear-gradient(90deg, #007bff, #00c6ff);
  //             color: white;
  //             padding: 6px 20px;
  //             border-radius: 20px;
  //             display: inline-block;
  //           }
  //         </style>
  //       </head>

  //       <body>
  //       <div class="border">

  //         <!-- HEADER -->
  //         <div class="school-header">
  //           <img src="${schoolLogo}" class="school-logo" />
  //           <div style="flex: 1;">
  //             <div class="school-name">${data.school.name}</div>
  //             <div class="school-contact">
  //               ${data.school.address}<br>
  //               ${data.school.phone ? "Phone: " + data.school.phone + " | " : ""}
  //               ${data.school.email}
  //             </div>
  //             <div class="certificate">CERTIFICATE OF MARKS</div>
  //             <div class="exam-title">${data.exam.exam_name}</div>
  //           </div>
  //         </div>

  //         <!-- STUDENT INFO -->
  //         <div class="student-box">
  //           <table class="info-table">
  //             <tr><td>Student Name</td><td>${data.student.name}</td></tr>
  //             <tr><td>Class</td><td>${data.student.class_name}</td></tr>
  //             <tr><td>Section</td><td>${data.student.section_name}</td></tr>
  //             <tr><td>Roll No</td><td>${data.student.roll_no}</td></tr>
  //           </table>

  //           <div class="photo-box">
  //             <img src="${studentPhoto}" width="100%" height="100%" />
  //           </div>
  //         </div>

  //         <!-- MARK TABLE -->
  //         <table class="marks-table" width="100%">
  //           <thead>
  //             <tr>
  //               <th>SUBJECT</th>

  //               ${markTypeHeaders.map(t => `<th>${t.title}</th>`).join("")}

  //               <th>TOTAL</th>
  //               <th>OBTAINED</th>
  //               <th>GRADE</th>
  //               <th>HIGHEST</th>
  //             </tr>
  //           </thead>

  //           <tbody>
  //             ${[...data.subjects.main, ...data.subjects.extra]
  //               .map(s => {
  //                 const typeCells = markTypeHeaders
  //                   .map(t => {
  //                     const item = (s.items || []).find(i => i.mark_type_id == t.mark_type_id);
  //                     return `<td>${item ? item.marks_obtained : "-"}</td>`;
  //                   })
  //                   .join("");

  //                 return `
  //                 <tr>
  //                   <td>${s.subject_name}</td>
  //                   ${typeCells}
  //                   <td>${s.total_marks}</td>
  //                   <td>${s.marks_obtained}</td>
  //                   <td>${s.grade}</td>
  //                   <td>${s.highest_marks}</td>
  //                 </tr>`;
  //               })
  //               .join("")}
  //           </tbody>

  //           <tfoot>
  //             <tr>
  //               <td style="text-align:right;"><b>TOTAL</b></td>

  //               ${markTypeHeaders.map(() => `<td></td>`).join("")}

  //               <td><b>${data.summary.total_marks}</b></td>
  //               <td><b>${data.summary.marks_obtained}</b></td>
  //               <td></td>
  //               <td></td>
  //             </tr>
  //           </tfoot>
  //         </table>

  //         <!-- SUMMARY -->
  //         <div class="summary-title">SUMMARY</div>
  //         <table class="summary-table" width="100%">
  //           <tr>
  //             <td>${data.summary.percentage}</td>
  //             <td>${data.summary.grade}</td>
  //             <td>${data.summary.result_status}</td>
  //           </tr>
  //         </table>

  //         <div class="footer">
  //           <div>Class Teacher</div>
  //           <div>Head Master</div>
  //         </div>

  //         <center>
  //           <div class="result-tag">
  //             Published on: ${new Date().toLocaleDateString("en-IN")}
  //           </div>
  //         </center>

  //       </div>

  //       <script>
  //         window.print();
  //         window.onafterprint = () => window.close();
  //       </script>

  //       </body>
  //       </html>
  //     `);

  //     printWin.document.close();

  //   } catch (err) {
  //     showToast("error", "Something went wrong!");
  //   }
  // };

  const generateMarksheet = async (
    student_id,
    exam_id,
    showPrevious = false,
    showWrittenOral = false
  ) => {
    try {
      const res = await api.get(
        `/student/mark-sheet/view/${student_id}/${exam_id}`,
        {
          params: {
            show_previous: showPrevious ? 1 : 0,
          },
        }
      );

      if (!res.data?.success) {
        showToast("error", "Failed to generate marksheet!");
        return;
      }

      const data = res.data.data;
//       console.log("===== MARKSHEET API DEBUG =====");
// console.log("Student:", data.student);
// console.log("School:", data.school);
// console.log("Subjects:", data.subjects.main);

// const bengaliDebug = (data.subjects.main || []).find(
//   (s) => (s.subject_name || "").toLowerCase().includes("bengali")
// );

// console.log("BENGALI DEBUG:", bengaliDebug);
// console.log("BENGALI TOTAL MARKS:", bengaliDebug?.total_marks);
// console.log("BENGALI OBTAINED:", bengaliDebug?.marks_obtained);

      const schoolId = Number(data.school?.id || 0);
      const classId = Number(data.student.class_id || 0);

      const schoolLogo = data.school.logo
        ? `https://dgps.co.in/public/admin/assets/img/schools/logo/${data.school.logo}`
        : "https://dgps.co.in/public/admin/assets/img/logo.png";

      const studentPhoto =
        data.student.file && data.student.file !== ""
          ? data.student.file
          : "https://cdn-icons-png.flaticon.com/512/3135/3135715.png";

      // ============================
      //  COMMON: MARK TYPE HEADERS
      //  (main + extra মিলিয়ে, default ডিজাইনের জন্য)
      // ============================
      const markTypeHeaders = (() => {
        const allSubjects = [
          ...(data.subjects.main || []),
          ...(data.subjects.extra || []),
        ];
        const allItems = allSubjects.flatMap((s) => s.items || []);
        const uniqueTypes = [];

        allItems.forEach((i) => {
          if (!uniqueTypes.find((u) => u.mark_type_id === i.mark_type_id)) {
            uniqueTypes.push({
              mark_type_id: i.mark_type_id,
              title: i.title || "Type",
            });
          }
        });

        return uniqueTypes;
      })();

      // Written/Oral columns are now UNIVERSAL and controlled by the page toggle.
      // All other mark-type columns remain available in the default design.
      const isWrittenOralTitle = (title = "") => {
        const normalized = String(title).trim().toLowerCase();
        return normalized === "written" || normalized === "oral";
      };

      const visibleMarkTypeHeaders = showWrittenOral
        ? markTypeHeaders
        : markTypeHeaders.filter((t) => !isWrittenOralTitle(t.title));

      // ==========================================================
      //  SPECIAL DESIGN : DGPS (school_id === 1) – SCREENSHOT STYLE
      // ==========================================================
      if (schoolId === 1 || schoolId === 30) {

        const bgImage =
          schoolId === 30
            ? "https://dgps.co.in/uploads/templates/marksheet/lf_exam_tem.png"
            : "https://dgps.co.in/uploads/templates/marksheet/dgps_exam_tem.jpg";


        const hmSignature =
          schoolId === 30
            ? "https://dgps.co.in/uploads/signature/teachers/ssss.png"
            : Number(classId) >= 1 && Number(classId) <= 6
              ? "https://dgps.co.in/uploads/signature/bl_hm.png"
              : "https://dgps.co.in/uploads/signature/upper_hm.png";


        const subjectOrder = [
          "bengali",
          "english",
          "arabic",
          "hindi",
          "arabic hindi",
          "arabic/hindi",
          "mathematics",
          "math",
          "science",
          "history",
          "geography",
          "gk",
          "conversation",
          "gk/conversation"
        ];

        const normalizeSubject = (name) =>
          (name || "")
            .toLowerCase()
            .trim()
            .replace(/\s+/g, " ");
            

        const mainSubjects = [...(data.subjects.main || [])].sort((a, b) => {
          const aName = normalizeSubject(a.subject_name);
          const bName = normalizeSubject(b.subject_name);

          const getIndex = (name) => {
            if (name.includes("bengali")) return 0;
            if (name.includes("english")) return 1;
            if (
              name.includes("arabic") ||
              name.includes("hindi")
            ) return 2;
            if (
              name.includes("mathematics") ||
              name.includes("math")
            ) return 3;
            if (name.includes("science")) return 4;
            if (name.includes("history")) return 5;
            if (name.includes("geography")) return 6;
            if (
              name.includes("gk") ||
              name.includes("conversation")
            ) return 7;

            return 999;
          };

          return getIndex(aName) - getIndex(bName);
        });
        const extraSubjects = data.subjects.extra || [];
        const otherSubjects = data.subjects?.other || [];
        const formatSubjectName = (name) => {
          // শুধু school_id = 30 এর জন্য 1st/2nd/3rd Language দেখাবে
          if (schoolId === 30) {
            const subject = (name || "").trim().toLowerCase();

            if (subject.includes("bengali")) {
              return "Bengali (1st Language)";
            }

            if (subject.includes("english")) {
              return "English (2nd Language)";
            }

            if (
              subject.includes("arabic") ||
              subject.includes("hindi")
            ) {
              return "Arabic Hindi (3rd Language)";
            }
          }

          // অন্যান্য সব school-এ subject name যেমন আছে তেমনই থাকবে
          return name;
        };
        const totalMainFull = mainSubjects.reduce(
          (sum, s) => sum + Number(s.total_marks || 0),
          0
        );
        const totalMainObt = mainSubjects.reduce(
          (sum, s) => sum + Number(s.marks_obtained || 0),
          0
        );
        const totalMainHighest = Number(
  data.summary?.highest_total || 0
);

        const percentage =
          data.summary?.percentage ??
          (totalMainFull
            ? Math.round((totalMainObt / totalMainFull) * 100)
            : 0);
        const maxSubjectMarks = Math.max(
          ...mainSubjects.map(sub => Number(sub.total_marks || 0))
        );

        const gradeRulesToUse =
          maxSubjectMarks <= 40
            ? (data.grade_rules_babyland || [])
            : (data.grade_rules || []);

        // const gradeRulesToUse =
        //   classId >= 1 && classId <= 6
        //     ? data.grade_rules_babyland || []
        //     : data.grade_rules || [];


        // Grade scale box – dynamic from grade_rules
        const gradeScaleRows = gradeRulesToUse
          .map((g) => {
            let min = parseFloat(g.min_percentage);
            let max = parseFloat(g.max_percentage);

            if (isNaN(min) || isNaN(max)) return "";

            // 🔹 Round logic for clean ranges
            const displayMin = Math.round(min);
            const displayMax = Math.floor(max);

            const range = `${displayMin} - ${displayMax}`;

            return `
              <tr>
                <td>${range}</td>
                <td>${g.grade}</td>
              </tr>
            `;
          })
          .join("");

        const currentScaleType =
          gradeRulesToUse.length > 0
            ? gradeRulesToUse[0].scale_type
            : 100;

        const gradeTitle = `Grade Scale (${currentScaleType})`;


        // Working days / present – আপাতত blank / API থাকলে use করব
        const workingDays = data.summary?.working_day || "";
        const presentDays = data.student?.present_day || "";

        // Formative evaluation (fixed for now)
        const evalGrades = {
          attendance: "AA",
          attitude: "A+",
          discipline: "AA",
          punctuality: "AA",
          morality: "AA",
          cleanliness: "AA",
          creativity: "A+",
          participation: "A+",
        };

        const examYear = data.exam.start_date
          ? new Date(data.exam.start_date).getFullYear()
          : "";

        const printWin = window.open("", "_blank");

        const termSummary = data.term_summary || null;

        const termSummaryHTML =
          termSummary &&
            (
              data.exam.exam_type === "final" ||
              data.exam.exam_type === "unit_test_2"
            )
            ? `
      <table class="term-summary">
        <tr>
          <th>Exams</th>
          <th>Full Marks</th>
          <th>Marks Obtained</th>
        </tr>

        <tr>
          <td><b>1st Term Total</b></td>
          <td>${termSummary.term_1.total_marks}</td>
          <td>${termSummary.term_1.marks_obtained}</td>
        </tr>

        <tr>
          <td><b>2nd Term Total</b></td>
          <td>${termSummary.term_2.total_marks}</td>
          <td>${termSummary.term_2.marks_obtained}</td>
        </tr>

        ${data.exam.exam_type === "final"
              ? `
              <tr>
                <td><b>Annual Total</b></td>
                <td>${data.summary.total_marks}</td>
                <td>${data.summary.marks_obtained}</td>
              </tr>

              <tr>
                <td><b>Overall Total</b></td>
                <td>${termSummary.overall.total_marks}</td>
                <td>${termSummary.overall.marks_obtained}</td>
              </tr>

              <tr>
                <td><b>Overall Percentage</b></td>
                <td colspan="2">
                  <b>${Number(termSummary.overall.percentage).toFixed(2)}%</b>
                </td>
              </tr>
            `
              : `
              <tr>
                <td><b>Combined Total</b></td>
                <td>${termSummary.overall.total_marks}</td>
                <td>${termSummary.overall.marks_obtained}</td>
              </tr>

              <tr>
                <td><b>Combined Percentage</b></td>
                <td colspan="2">
                  <b>${Number(termSummary.overall.percentage).toFixed(2)}%</b>
                </td>
              </tr>
            `
            }

      </table>
    `
            : "";


        printWin.document.write(`
        <html>
        <head>
        <link href="https://fonts.googleapis.com/css2?family=Oswald:wght@400;500;600;700&display=swap" rel="stylesheet">
          <title>Marksheet - ${data.student.name}</title>
          <style>
            @page {
              size: A4 portrait;
              margin: 0;
            }
            body {
              margin: 0;
              font-family:  Arial, sans-serif;
              background: #f0f0f0;
            }
            .page {
              position: relative;
              width: 794px;
              height: 1123px;
              margin: 0 auto;
              background: url('${bgImage}') no-repeat center top;
              background-size: 100% 100%;
            }
            .content {
              position: absolute;
              top: 50px;
              left: 70px;
              right: 75px;
              bottom: 80px;
              font-size: 12px;
            }
            /* TOP SCHOOL HEADER (NEW) */
            .school-head {
              text-align: center;
              margin-top: 5px;
            }
            .school-head-name {
              font-family: 'Oswald', sans-serif;
              font-weight: 700; /* Bold */
              font-size: 36px;
              letter-spacing: 1px;
              text-align: center;
            }
            .school-head-sub {
              font-size: 15px;
              margin-top: 2px;
              font-weight: bold;
            }
            .school-separator {
              border: none;
              border-top: 2px solid #000;
              margin: 10px 0;
            }
            .title-line {
              text-align: center;
              font-weight: 700;
              font-size: 13px;
              margin-top: 10px;
            }
            .student-line {
              margin-top: 8px;
              font-size: 15px;
            }
            .student-line b {
              font-weight: 700;
            }
            .flex-row {
              display: flex;
              align-items: flex-start;
              margin-top: 10px;
            }
            .left-section {
              flex: 1;
            }
            .photo-box {
              width: 95px;
              height: 110px;
              overflow: hidden;
              margin-left: 10px;
            }
            .photo-box img {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 10px;
            }
            .marks-main {
              width: 100%;
              border-collapse: collapse;
              margin-top: 6px;
            }
            .term-summary {
              width: 100%;
              border-collapse: collapse;
              margin-top: 8px;
              font-size: 11px;
            }

            .term-summary th,
            .term-summary td {
                border: 1px solid #000;
                padding: 4px 6px;
                text-align: center;
            }

            .term-summary th {
              background: #f4b183;
              font-weight: 700;
            }

            .term-summary td:first-child {
              text-align: left;
              font-weight: 700;
            }

            .marks-main th,
            .marks-main td {
              border: 1px solid #000;
              padding: 3px 4px;
              text-align: center;
              font-size: 11px;
            }
            .marks-main th {
              background: #cce3aa;
              font-weight: 700;
            }
            .marks-main td.subject-name {
              text-align: left;
            }
            .marks-main tfoot td {
              font-weight: 700;
            }

            /* Grade scale box right side */
            .grade-box-wrapper {
              width: 170px;
              margin-left: 12px;
              
            }
            .grade-box-title {
              background: #cce3aa;
              border: 1px solid #000;
              border-bottom: none;
              padding: 3px 4px;
              font-size: 11px;
              font-weight: 700;
              text-align: center;
              margin-top: 10px;
            }
            .grade-box-table {
              width: 100%;
              border-collapse: collapse;
              font-size: 11px;
            }
            .grade-box-table th,
            .grade-box-table td {
              border: 1px solid #000;
              padding: 2px 4px;
              text-align: center;
            }
            .section-title {
              text-align: center;
              font-size: 11px;
              font-weight: 700;
              margin-top: 8px;
              text-decoration: underline;
            }
            .extra-table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 4px;
            }
            .extra-table th,
            .extra-table td {
              border: 1px solid #000;
              padding: 3px 4px;
              text-align: center;
              font-size: 11px;
            }
            .extra-table th {
              background: #cce3aa;
              font-weight: 700;
            }
            .extra-table td.subject-name {
              text-align: left;
            }

            .days-table {
              margin-top: 8px;
              font-size: 11px;
              border-collapse: collapse;
            }
            .days-table td {
              border: 1px solid #000;
              padding: 2px 6px;
            }
            .days-table td.label {
              width: 120px;
            }

            .eval-title {
              text-align: center;
              font-size: 11px;
              font-weight: 700;
              margin-top: 6px;
            }
            .eval-table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 3px;
              font-size: 10px;
            }
            .eval-table th,
            .eval-table td {
              border: 1px solid #000;
              padding: 2px 3px;
              text-align: center;
            }
            .eval-table th {
              background: #cce3aa;
              font-weight: 700;
            }
            .eval-empty {
              padding: 14px;
              text-align: center;
              font-size: 13px;
              color: #555;
              background: #f9fafb;
              border: 1px dashed #cbd5e1;
              border-radius: 6px;
              margin-top: 8px;
            }
            .footer-sign {
              position: absolute;
              bottom: 0px;
              left: 60px;
              right: 60px;
              display: flex;
              justify-content: space-between;
              font-size: 11px;
            }

            /* 🔹 each signature column */
            .sign-box {
              width: 160px;
              text-align: center;
            }

            /* 🔹 signature image container */
            .sign-space {
              width: 140px;
              height: 60px;
              margin: 0 auto 6px;
              display: flex;
              align-items: center;
              justify-content: center;
            }

            /* 🔹 signature image */
            .sign-space img {
              max-width: 100%;
              max-height: 100%;
              object-fit: contain;
            }

            /* 🔹 label line */
            .sign-label {
              padding-top: 4px;
              font-weight: 600;
            }

          </style>
        </head>
        <body>
          <div class="page">
            <div class="content">
              <!-- SCHOOL HEADER (TOP) -->
              <div class="school-head">
  <div class="school-head-name">${data.school.name}</div>

  ${schoolId === 30
            ? `
      <div class="school-head-sub">
        School Code : 19070612203
      </div>

      <div class="school-head-sub">
        A Project of :
      </div>

      <div class="school-head-sub">
        Gangapur Nurudduza Khatun Educational & Social Welfare Society
      </div>

      <div style="
        display: inline-block;
        background: #a3122a;
        color: #ffffff;
        font-weight: 700;
        padding: 3px 12px;
        margin-top: 4px;
        font-size: 15px;
      ">
        Govt. Regd. No. S/IL/42575 of 2006-07
      </div>

   
      <div class="school-head-sub" style="margin-top: 4px;">
        Vill- Gangapur, P.O.- Bhabta, Dist.- Murshidabad, Pin- 742134, W.B
      </div>
         <div class="school-head-sub" style="margin-top: 4px;">
        Mobile: 9933125678
        ${data.school.email
              ? ` | Email: ${data.school.email}`
              : ""
            }
      </div>

    `
            : `
      <div class="school-head-sub">
        (Residential & Non-Residential School)
      </div>
      <div class="school-head-sub">
        Govt. Regd. No. S/2L/52858
      </div>
    `
          }
</div>
              <hr/ class="school-separator" />
              <div class="title-line">
                PROGRESS REPORT OF ${data.exam.exam_name.toUpperCase()} 
              </div>

              <div class="student-line">
                Name of Student – <b>${data.student.name}</b>
                &nbsp;&nbsp; Class – <b>${data.student.class_name}</b>
                &nbsp;&nbsp; SEC – <b>${data.student.section_name}</b>
                &nbsp;&nbsp; Roll No – <b>${data.student.roll_no}</b>
              </div>

              <div class="flex-row">
                <div class="left-section">
                  <table class="marks-main">
                    <thead>
                    <tr>
  <th>Subject</th>
  <th>Full Marks</th>
  ${showWrittenOral
            ? `
        <th>Written</th>
        <th>Oral</th>
        <th>Total</th>
      `
            : `
        <th>Marks Obtained</th>
      `
          }
  <th>Grade</th>
  <th>Highest Marks</th>
</tr>
                    </thead>
                    <tbody>
                    ${mainSubjects
            .map((s) => {
              const written =
                (s.items || []).find(
                  (i) => String(i.title || "").trim().toLowerCase() === "written"
                )?.marks_obtained || "";

              const oral =
                (s.items || []).find(
                  (i) => String(i.title || "").trim().toLowerCase() === "oral"
                )?.marks_obtained || "";

              return `
      <tr>
       <td class="subject-name">${formatSubjectName(s.subject_name)}</td>
        <td>${s.total_marks}</td>
        ${showWrittenOral
                  ? `
              <td>${written}</td>
              <td>${oral}</td>
              <td>${s.marks_obtained}</td>
            `
                  : `
              <td>${s.marks_obtained}</td>
            `
                }
        <td>${s.grade}</td>
        <td>${s.highest_marks}</td>
      </tr>
    `;
            })
            .join("")}
                    </tbody>
                    <tfoot>
                      <tr>
  <td>Total</td>
  <td>${totalMainFull}</td>
  ${showWrittenOral
            ? `
        <td></td>
        <td></td>
        <td>${totalMainObt}</td>
      `
            : `
        <td>${totalMainObt}</td>
      `
          }
<td>${data.summary.grade}</td>
<td>${totalMainHighest}</td>
</tr>
                     <tr>
  <td>Percentage</td>
  ${showWrittenOral
            ? `
        <td colspan="6" style="text-align:center;">
          ${percentage}
        </td>
      `
            : `
        <td colspan="4" style="text-align:center;">
          ${percentage}
        </td>
      `
          }
</tr>

 <tr>
 ${schoolId === 30
            ? `
      <tr>
        <td>Position</td>
        <td colspan="6" style="text-align:center;">
          ${data.summary.position || ""}
        </td>
      </tr>
    `
            : ""
          }

</tr>

                    </tfoot>
                  </table>
                  ${termSummaryHTML}

                </div>

                <div class="grade-box-wrapper">
                  <div class="photo-box">
                    <img src="${studentPhoto}" alt="Student" />
                  </div>

                <div class="grade-box-title">${gradeTitle}</div>
<table class="grade-box-table">
  <thead>
    <tr>
      <th>Marks</th>
      <th>Grade</th>
    </tr>
  </thead>
  <tbody>
    ${gradeScaleRows}
  </tbody>
</table>

${schoolId === 30
            ? `
      <div style="
        border: 1px solid #000;
        border-top: none;
        text-align: center;
        font-size: 11px;
        font-weight: 700;
        padding: 4px;
      ">
        Pass Mark: 17
      </div>
    `
            : ""
          }
                </div>
              </div>

              ${extraSubjects.length > 0
            ? `
                  <div class="section-title">: EXTRA CURRICULUM ACTIVITIES :</div>

                  <table class="extra-table">
                    <thead>
                      <tr>
                        <th>Subject</th>
                        <th>Full Marks</th>
                        <th>Marks Obtained</th>
                        <th>Grade</th>
                        <th>Highest Marks</th>
                      </tr>
                    </thead>
                    <tbody>
                      ${extraSubjects
              .map(
                (s) => `
                            <tr>
                            <td class="subject-name">${formatSubjectName(s.subject_name)}</td>
                              <td>${s.total_marks}</td>
                              <td>${s.marks_obtained}</td>
                              <td>${s.grade}</td>
                              <td>${s.highest_marks}</td>
                            </tr>
                          `
              )
              .join("")}
                    </tbody>
                  </table>
                `
            : ""
          }

<table class="days-table">
  <tr>
    <td class="label">No. of Working Days</td>
    <td>
      ${schoolId === 30 ? 84 : workingDays}
    </td>
  </tr>
  <tr>
    <td class="label">Days Present</td>
    <td>${presentDays}</td>
  </tr>
</table>

          ${otherSubjects.length
            ? `
      <div class="eval-title">
        Grade Based Students Performance (Formative Evaluation)
      </div>

      <table class="eval-table">
        <thead>
          <tr>
            ${otherSubjects
              .map(
                (sub) => `
                  <th>
                    ${sub.subject_name}<br/>
                    F.M-${sub.total_marks}
                  </th>
                `
              )
              .join("")}
          </tr>
        </thead>

        <tbody>
          <tr>
            ${otherSubjects
              .map(
                (sub) => `
                  <td>${sub.grade || "-"}</td>
                `
              )
              .join("")}
          </tr>
        </tbody>
      </table>
    `
            : ""}
               <div class="footer-sign">
                <!-- Class Teacher (Empty) -->
                <div class="sign-box">
          <div class="sign-space">

        ${schoolId === 1
            ? (() => {

              let cls = String(data.student.class_name || "")
                .trim()
                .toUpperCase()
                .replace(/\s+/g, "");

              let sec = String(data.student.section_name || "")
                .trim()
                .toUpperCase()
                .replace(/\s+/g, "");

              let fileName = "";

              // Nursery special
              if (cls === "NURSERY") {
                fileName = "nursery.png";
              } else {
                fileName = `${cls}-${sec}.png`;
              }

              const imgUrl = `https://dgps.co.in/uploads/signature/teacher/${fileName}`;

              return `
          <img 
            src="${imgUrl}" 
            alt=""
            onerror="this.style.display='none'"
          />
        `;

            })()
            : ""
          }

              </div>

              <div class="sign-label">
                Signature of Class Teacher
              </div>
            </div>

                <!-- Headmaster (With Signature) -->
                <div class="sign-box">
                  <div class="sign-space">
                    <img src="${hmSignature}" alt="Headmaster Signature" />
                  </div>
                  <div class="sign-label">Signature of Headmaster</div>
                </div>
              </div>

            </div>
          </div>

          <script>
            window.print();
            window.onafterprint = () => window.close();
          </script>
        </body>
        </html>
      `);

        printWin.document.close();
        return;
      }

      // =====================================
      //  DEFAULT DESIGN (OTHER SCHOOLS)
      //  — আপনার আগের ডিজাইন একদম 그대로
      // =====================================
      const printWin = window.open("", "_blank");

      printWin.document.write(`
      <html>
      <head>
        <title>Marksheet - ${data.student.name}</title>
        <style>
          @page {
            size: A4 portrait;
            margin: 10mm;
          }

          body {
            font-family: "Poppins", Arial, sans-serif;
            margin: 0;
            background: #f8faff;
            color: #000;
          }

          .border {
            border: 10px double #0056d6;
            padding: 25px 35px;
            background: #fff;
            border-radius: 8px;
            max-width: 800px;
            margin: auto;
            box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          }
          .school-header {
            display: flex;
            align-items: center;
            justify-content: space-between;
            border-bottom: 2px solid #0056d6;
            padding-bottom: 10px;
            margin-bottom: 15px;
          }

          .school-logo {
            width: 90px;
            height: 90px;
            object-fit: contain;
          }

          .school-text {
            flex-grow: 1;
            text-align: center;
          }

          .school-name {
            font-size: 24px;
            font-weight: 800;
            color: #003a80;
            text-transform: uppercase;
          }

          .school-contact {
            font-size: 12.5px;
            color: #444;
            line-height: 1.4;
          }

          .certificate {
            color: #00723e;
            font-weight: 700;
            text-decoration: underline;
            font-size: 15px;
            margin-top: 5px;
            text-align: center;
          }

          .exam-title {
            color: #000;
            font-weight: 700;
            font-size: 14px;
            margin-top: 3px;
            text-align: center;
          }

          .student-box {
            border: 1px solid #0056d6;
            background: #f9fbff;
            padding: 12px;
            border-radius: 6px;
            display: grid;
            grid-template-columns: 1fr 130px;
            gap: 20px;
            margin-bottom: 20px;
          }

          .info-table td {
            padding: 6px;
            font-size: 13px;
            border-bottom: 1px dashed #999;
          }

          .info-table td:first-child {
            font-weight: 600;
            color: #003a80;
          }

          .photo-box {
            width: 130px;
            height: 150px;
            border: 2px solid #007bff;
            overflow: hidden;
            border-radius: 8px;
          }

          .marks-table th {
            background: #d7e9ff;
            border: 1px solid #0056d6;
            padding: 8px;
            font-size: 13px;
          }

          .marks-table td {
            border: 1px solid #9dbdfc;
            padding: 6px;
            font-size: 13px;
            text-align: center;
          }

          .summary-title {
            background: #dce8ff;
            border: 1px solid #0056d6;
            text-align: center;
            padding: 6px;
            font-weight: 700;
            margin-top: 25px;
          }

          .summary-table td,
          .summary-table th {
            border: 1px solid #9dbdfc;
            padding: 6px;
            font-size: 13px;
            text-align: center;
          }

          .footer {
            display: flex;
            justify-content: space-between;
            margin-top: 40px;
            font-weight: 600;
            color: #0056d6;
          }

          .result-tag {
            margin-top: 20px;
            background: linear-gradient(90deg, #007bff, #00c6ff);
            color: white;
            padding: 6px 20px;
            border-radius: 20px;
            display: inline-block;
          }
        </style>
      </head>

      <body>
      <div class="border">
        <!-- HEADER -->
        <div class="school-header">
          <img src="${schoolLogo}" class="school-logo" alt="Logo"/>
          <div class="school-text">
            <div class="school-name">${data.school.name}</div>
            <div class="school-contact">
              ${data.school.address}<br>
              ${data.school.phone ? "Phone: " + data.school.phone + " | " : ""}
              ${data.school.email ? data.school.email : ""}
            </div>
            <div class="certificate">CERTIFICATE OF MARKS</div>
            <div class="exam-title">${data.exam.exam_name.toUpperCase()}</div>
          </div>
        </div>

        <!-- STUDENT INFO -->
        <div class="student-box">
          <table class="info-table">
            <tr><td>Student Name</td><td>${data.student.name}</td></tr>
            <tr><td>Father’s Name</td><td>${data.student.father_name}</td></tr>
            <tr><td>Mother’s Name</td><td>${data.student.mother_name}</td></tr>
            <tr><td>Student Code</td><td>${data.student.student_code || ""}</td></tr>
            <tr><td>Class</td><td>${data.student.class_name}</td></tr>
            <tr><td>Section</td><td>${data.student.section_name}</td></tr>
            <tr><td>Roll No</td><td>${data.student.roll_no}</td></tr>
            <tr><td>Date of Birth</td><td>${data.student.dob}</td></tr>
          </table>

          <div class="photo-box">
            <img src="${studentPhoto}" width="100%" height="100%" />
          </div>
        </div>

        <!-- MARKS TABLE -->
        <table class="marks-table" width="100%">
          <thead>
            <tr>
              <th>SUBJECT</th>
              ${visibleMarkTypeHeaders.map((t) => `<th>${t.title}</th>`).join("")}
              <th>TOTAL</th>
              <th>OBTAINED</th>
              <th>GRADE</th>
              <th>HIGHEST</th>
            </tr>
          </thead>

          <tbody>
            ${[...(data.subjects.main || []), ...(data.subjects.extra || [])]
          .map((s) => {
            const typeCells = visibleMarkTypeHeaders
              .map((t) => {
                const item = (s.items || []).find(
                  (i) => i.mark_type_id == t.mark_type_id
                );
                return `<td>${item ? item.marks_obtained : "-"}</td>`;
              })
              .join("");

            return `
                  <tr>
                    <td>${s.subject_name}</td>
                    ${typeCells}
                    <td>${s.total_marks}</td>
                    <td>${s.marks_obtained}</td>
                    <td>${s.grade}</td>
                    <td>${s.highest_marks}</td>
                  </tr>
                `;
          })
          .join("")}
          </tbody>

          <tfoot>
            <tr>
              <td style="text-align:right;"><b>TOTAL</b></td>
              ${visibleMarkTypeHeaders.map(() => `<td></td>`).join("")}
              <td><b>${data.summary.total_marks}</b></td>
              <td><b>${data.summary.marks_obtained}</b></td>
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>

        <!-- SUMMARY -->
    
        <div class="summary-title">SUMMARY</div>
        <table class="summary-table" width="100%">
          <tr>
            <th>PERCENTAGE (%)</th>
            <th>GRADE</th>
            <th>RESULT</th>
          </tr>
          <tr>
            <td>${data.summary.percentage}</td>
            <td>${data.summary.grade}</td>
            <td>${data.summary.result_status?.toUpperCase() || "PASS"}</td>
          </tr>
        </table>

        <!-- FOOTER -->
        <div class="footer">
          <div>Class Teacher</div>
          <div>Head Master</div>
        </div>

        <center>
          <div class="result-tag">
            Published on: ${new Date().toLocaleDateString("en-IN")}
          </div>
        </center>

      </div>

      <script>
        window.print();
        window.onafterprint = () => window.close();
      </script>

      </body>
      </html>
    `);

      printWin.document.close();
    } catch (err) {
      console.error(err);
      showToast("error", "Something went wrong!");
    }
  };

  const downloadExcel = (rows, fileName = "Class_Marksheet.xlsx") => {
    if (!rows || !rows.length) {
      alert("No data to export");
      return;
    }

    // Convert JSON → Worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows);

    // Auto width
    const colWidths = Object.keys(rows[0]).map((key) => ({
      wch: Math.max(
        key.length,
        ...rows.map((r) => String(r[key] ?? "").length)
      ) + 2,
    }));
    worksheet["!cols"] = colWidths;

    // Workbook
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Marksheet");

    // Export
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    const blob = new Blob([excelBuffer], {
      type: "application/octet-stream",
    });

    saveAs(blob, fileName);
  };


  const downloadClassMarksheetExcel = async () => {
    if (!form.exam_id || !form.class_id || !form.section_id) {
      showToast("error", "Please select Exam, Class and Section");
      return;
    }

    try {
      setLoading(true);

      const res = await api.post(
        "/student/mark-sheet/class_wise",
        {
          exam_id: form.exam_id.id,
          class_id: form.class_id.id,
          section_id: form.section_id.id,
        }
      );

      if (!res.data?.success || !res.data.data?.length) {
        showToast("warning", "No data found");
        return;
      }

      const examName = form.exam_id.exam_name.replace(/\s+/g, "_");
      const className = form.class_id.class_name.replace(/\s+/g, "_");
      const sectionName = form.section_id.section_name;

      downloadExcel(
        res.data.data,
        `Marksheet_${examName}_${className}_${sectionName}.xlsx`
      );

      showToast("success", "Excel downloaded successfully!");
    } catch (err) {
      console.error(err);
      showToast("error", "Failed to download Excel");
    } finally {
      setLoading(false);
    }
  };


  const previousResultAvailable =
    form.exam_id?.exam_type === "unit_test_2" ||
    String(form.exam_id?.exam_name || "")
      .toLowerCase()
      .includes("2nd term");

  useEffect(() => {
    if (!previousResultAvailable && showPreviousResult) {
      setShowPreviousResult(false);
    }
  }, [previousResultAvailable, showPreviousResult]);

  return (
    <div style={styles.page}>
      <ToastContainer />
      <div style={styles.titleBlock}>
        <p style={styles.eyebrow}>EXAMS & RESULTS</p>
        <h2 style={styles.title}>🎓 Student Marksheet List</h2>
        <p style={styles.subtitle}>Search students and generate their examination marksheets.</p>
      </div>

      {/* Filter Section */}
      <div style={styles.card}>
        <div style={styles.filterRow}>
          <div style={styles.filterItem}>
            <label style={styles.label}>Exam</label>
            <Select
              getOptionLabel={(e) => e.exam_name}
              getOptionValue={(e) => e.id}
              options={exams}
              value={form.exam_id}
              onChange={(v) => handleChange("exam_id", v)}
              placeholder="Select Exam"
            />
          </div>

          <div style={styles.filterItem}>
            <label style={styles.label}>Class</label>
            <Select
              getOptionLabel={(e) => e.class_name}
              getOptionValue={(e) => e.id}
              options={classes}
              value={form.class_id}
              onChange={(v) => handleChange("class_id", v)}
              placeholder="Select Class"
            />
          </div>

          <div style={styles.filterItem}>
            <label style={styles.label}>Section</label>
            <Select
              getOptionLabel={(e) => e.section_name}
              getOptionValue={(e) => e.id}
              options={sections}
              value={form.section_id}
              onChange={(v) => handleChange("section_id", v)}
              placeholder="Select Section"
            />
          </div>
          {(() => {
            const previousResultAvailable =
              form.exam_id?.exam_type === "unit_test_2" ||
              String(form.exam_id?.exam_name || "")
                .toLowerCase()
                .includes("2nd term");

            return (
              <div ref={settingsRef} style={styles.settingsWrap}>
                <button
                  type="button"
                  aria-label="Open marksheet settings"
                  aria-expanded={showSettings}
                  onClick={() => setShowSettings((prev) => !prev)}
                  style={
                    showSettings
                      ? styles.btnSettingsActive
                      : styles.btnSettings
                  }
                  title="Marksheet Settings"
                >
                  <FaCog
                    style={{
                      transform: showSettings ? "rotate(75deg)" : "rotate(0deg)",
                      transition: "transform 0.35s ease",
                    }}
                  />
                  <span>Settings</span>
                  {(showWrittenOral || showPreviousResult) && (
                    <span style={styles.settingsActiveDot} />
                  )}
                </button>

                <div
                  style={{
                    ...styles.settingsDropdown,
                    ...(showSettings
                      ? styles.settingsDropdownOpen
                      : styles.settingsDropdownClosed),
                  }}
                  aria-hidden={!showSettings}
                >
                  <div style={styles.settingsHeader}>
                    <div>
                      <div style={styles.settingsTitle}>Marksheet Settings</div>
                      <div style={styles.settingsSubtitle}>
                        Control what appears on the generated marksheet.
                      </div>
                    </div>
                    <button
                      type="button"
                      onClick={() => setShowSettings(false)}
                      style={styles.settingsClose}
                      aria-label="Close settings"
                    >
                      ×
                    </button>
                  </div>

                  <div style={styles.settingsDivider} />

                  <div style={styles.settingsItem}>
                    <div style={styles.settingsItemText}>
                      <div style={styles.settingsItemTitle}>
                        Written + Oral
                      </div>
                      <div style={styles.settingsItemDescription}>
                        Show Written, Oral and Total columns where available.
                      </div>
                    </div>

                    <button
                      type="button"
                      role="switch"
                      aria-checked={showWrittenOral}
                      onClick={() => setShowWrittenOral((prev) => !prev)}
                      style={
                        showWrittenOral
                          ? styles.toggleTrackOn
                          : styles.toggleTrackOff
                      }
                      title={
                        showWrittenOral
                          ? "Turn off Written + Oral"
                          : "Turn on Written + Oral"
                      }
                    >
                      <span
                        style={
                          showWrittenOral
                            ? styles.toggleKnobOn
                            : styles.toggleKnobOff
                        }
                      />
                    </button>
                  </div>

                  <div style={styles.settingsItem}>
                    <div style={styles.settingsItemText}>
                      <div style={styles.settingsItemTitle}>
                        Previous Exam Result
                      </div>
                      <div style={styles.settingsItemDescription}>
                        Show the previous exam result on supported exams.
                      </div>
                      {!previousResultAvailable && (
                        <div style={styles.settingsDisabledNote}>
                          Available for Unit Test 2 / 2nd Term exams.
                        </div>
                      )}
                    </div>

                    <button
                      type="button"
                      role="switch"
                      aria-checked={
                        previousResultAvailable && showPreviousResult
                      }
                      disabled={!previousResultAvailable}
                      onClick={() =>
                        setShowPreviousResult((prev) => !prev)
                      }
                      style={
                        !previousResultAvailable
                          ? styles.toggleTrackDisabled
                          : showPreviousResult
                            ? styles.toggleTrackOn
                            : styles.toggleTrackOff
                      }
                      title={
                        !previousResultAvailable
                          ? "Not available for this exam"
                          : showPreviousResult
                            ? "Turn off Previous Exam Result"
                            : "Turn on Previous Exam Result"
                      }
                    >
                      <span
                        style={
                          !previousResultAvailable
                            ? styles.toggleKnobDisabled
                            : showPreviousResult
                              ? styles.toggleKnobOn
                              : styles.toggleKnobOff
                        }
                      />
                    </button>
                  </div>

                  <div style={styles.settingsFooter}>
                    <span>
                      {showWrittenOral || showPreviousResult
                        ? "Custom settings enabled"
                        : "Default marksheet view"}
                    </span>
                  </div>
                </div>
              </div>
            );
          })()}

          <button style={styles.btnSearch} onClick={handleSearch}>
            {loading ? "Loading..." : <><FaSearch /> Search</>}
          </button>
          <button
            style={{
              background: "linear-gradient(90deg,#16a34a,#22c55e)",
              color: "#fff",
              padding: "10px 18px",
              borderRadius: "8px",
              border: "none",
              cursor: "pointer",
              fontWeight: 600,
            }}
            onClick={downloadClassMarksheetExcel}
          >
            📥 Download Excel
          </button>
        </div>

      </div>

      {/* Result Table */}
      <div style={styles.tableWrapper}>
        {loading ? (
          <p style={styles.noData}>⏳ Fetching data...</p>
        ) : marksheets.length > 0 ? (
          <table style={styles.table}>


            <thead>
              <tr>
                <th style={styles.tableHeader}>#</th>
                <th style={styles.tableHeader}>Photo</th>
                <th style={styles.tableHeader}>Student</th>
                <th style={styles.tableHeader}>Class</th>
                <th style={styles.tableHeader}>Section</th>
                <th style={styles.tableHeader}>Roll</th>
                <th style={styles.tableHeader}>Exam</th>
                <th style={styles.tableHeader}>Action</th>
              </tr>
            </thead>

            
            <tbody>
              {marksheets.map((s, i) => (
                <tr key={i}>
                  <td style={styles.tableCellNumber}>{i + 1}</td>
                  <td style={styles.tableCell}>
                    <img
                      src={
                        s.photo ||
                        "https://cdn-icons-png.flaticon.com/512/149/149071.png"
                      }
                      alt="student"
                      style={styles.photo}
                    />
                  </td>
                  <td style={styles.tableCellStudent}>{s.student_name}</td>
                  <td style={styles.tableCell}>{s.class_name}</td>
                  <td style={styles.tableCell}>{s.section_name}</td>
                  <td style={styles.tableCell}>{s.roll_no}</td>
                  <td style={styles.tableCellExam}>{s.exam_name}</td>
                  <td style={styles.tableCellAction}>
                    <button
                      style={styles.btnView}
                      onClick={() =>
                        generateMarksheet(
                          s.id,
                          form.exam_id.id,
                          showPreviousResult,
                          showWrittenOral
                        )
                      }
                    >
                      <FaFilePdf /> Generate Marksheet
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <p style={styles.noData}>No marksheet found</p>
        )}
      </div>
    </div>
  );
};

export default StudentMarksheetListPage;

const styles = {
  page: {
    padding: "clamp(24px, 4vw, 44px)",
    background: "linear-gradient(135deg, #f5f8fc 0%, #eef4f8 58%, #eaf7f2 100%)",
    minHeight: "100vh",
  },
  titleBlock: {
    textAlign: "center",
    marginBottom: "26px",
  },
  eyebrow: {
    margin: "0 0 7px",
    color: "#16805b",
    fontSize: "11px",
    fontWeight: "800",
    letterSpacing: "1.6px",
  },
  title: {
    margin: 0,
    fontSize: "clamp(22px, 2.4vw, 30px)",
    color: "#17324d",
    fontWeight: "800",
  },
  subtitle: {
    margin: "8px 0 0",
    color: "#6b7c8f",
    fontSize: "13px",
  },
  card: {
    background: "rgba(255, 255, 255, 0.96)",
    padding: "24px",
    border: "1px solid rgba(207, 220, 232, 0.8)",
    borderRadius: "12px",
    boxShadow: "0 12px 30px rgba(30, 60, 90, 0.08)",
    marginBottom: "24px",
  },
  filterRow: {
    display: "flex",
    flexWrap: "wrap",
    gap: "18px",
    alignItems: "flex-end",
  },
  filterItem: {
    flex: 1,
    minWidth: "210px",
  },
  label: {
    display: "block",
    marginBottom: "8px",
    fontWeight: "700",
    color: "#34495e",
    fontSize: "12px",
    letterSpacing: "0.2px",
  },
  settingsWrap: {
    position: "relative",
    display: "flex",
    alignItems: "flex-end",
    zIndex: 50,
  },
  btnSettings: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minHeight: "42px",
    padding: "10px 16px",
    borderRadius: "10px",
    border: "1px solid #d6dee7",
    background: "#ffffff",
    color: "#334155",
    fontWeight: "700",
    fontSize: "13px",
    cursor: "pointer",
    boxShadow: "0 6px 18px rgba(15, 23, 42, 0.07)",
    transition: "all 0.25s ease",
    whiteSpace: "nowrap",
  },
  btnSettingsActive: {
    position: "relative",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
    minHeight: "42px",
    padding: "10px 16px",
    borderRadius: "10px",
    border: "1px solid #bfdbfe",
    background: "linear-gradient(135deg, #eff6ff, #dbeafe)",
    color: "#1d4ed8",
    fontWeight: "800",
    fontSize: "13px",
    cursor: "pointer",
    boxShadow: "0 8px 22px rgba(37, 99, 235, 0.14)",
    transition: "all 0.25s ease",
    whiteSpace: "nowrap",
  },
  settingsActiveDot: {
    width: "7px",
    height: "7px",
    borderRadius: "50%",
    background: "#22c55e",
    boxShadow: "0 0 0 3px rgba(34, 197, 94, 0.14)",
    marginLeft: "1px",
  },
  settingsDropdown: {
    position: "absolute",
    top: "calc(100% + 10px)",
    right: 0,
    width: "360px",
    background: "rgba(255, 255, 255, 0.98)",
    border: "1px solid #dbe4ed",
    borderRadius: "16px",
    boxShadow: "0 18px 50px rgba(15, 23, 42, 0.16)",
    overflow: "hidden",
    transformOrigin: "top right",
    transition: "opacity 0.22s ease, transform 0.22s ease, max-height 0.28s ease",
    maxHeight: "420px",
    zIndex: 1000,
  },
  settingsDropdownOpen: {
    opacity: 1,
    transform: "translateY(0) scale(1)",
    pointerEvents: "auto",
  },
  settingsDropdownClosed: {
    opacity: 0,
    transform: "translateY(-8px) scale(0.98)",
    pointerEvents: "none",
    maxHeight: "0px",
  },
  settingsHeader: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    gap: "12px",
    padding: "16px 17px 14px",
    background: "linear-gradient(135deg, #f8fbff, #eef5ff)",
  },
  settingsTitle: {
    color: "#17324d",
    fontSize: "14px",
    fontWeight: "800",
    marginBottom: "4px",
  },
  settingsSubtitle: {
    color: "#708197",
    fontSize: "11px",
    lineHeight: 1.45,
  },
  settingsClose: {
    width: "30px",
    height: "30px",
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    border: "1px solid #dbe4ed",
    borderRadius: "8px",
    background: "#fff",
    color: "#64748b",
    fontSize: "19px",
    lineHeight: 1,
    cursor: "pointer",
  },
  settingsDivider: {
    height: "1px",
    background: "#e7edf3",
  },
  settingsItem: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "16px",
    padding: "17px",
  },
  settingsItemText: {
    flex: 1,
    minWidth: 0,
  },
  settingsItemTitle: {
    color: "#1e293b",
    fontSize: "13px",
    fontWeight: "800",
    marginBottom: "4px",
  },
  settingsItemDescription: {
    color: "#718096",
    fontSize: "11px",
    lineHeight: 1.5,
  },
  settingsDisabledNote: {
    marginTop: "5px",
    color: "#b45309",
    fontSize: "10px",
    fontWeight: "700",
  },
  settingsFooter: {
    padding: "11px 17px",
    background: "#f8fafc",
    borderTop: "1px solid #edf2f7",
    color: "#64748b",
    fontSize: "10px",
    fontWeight: "700",
  },
  toggleTrackOn: {
    position: "relative",
    flex: "0 0 auto",
    width: "48px",
    height: "27px",
    padding: 0,
    border: "none",
    borderRadius: "999px",
    background: "linear-gradient(90deg, #16a34a, #22c55e)",
    cursor: "pointer",
    transition: "background 0.22s ease, box-shadow 0.22s ease",
    boxShadow: "0 4px 12px rgba(34, 197, 94, 0.28)",
  },
  toggleTrackOff: {
    position: "relative",
    flex: "0 0 auto",
    width: "48px",
    height: "27px",
    padding: 0,
    border: "none",
    borderRadius: "999px",
    background: "#cbd5e1",
    cursor: "pointer",
    transition: "background 0.22s ease, box-shadow 0.22s ease",
    boxShadow: "inset 0 0 0 1px rgba(71, 85, 105, 0.06)",
  },
  toggleTrackDisabled: {
    position: "relative",
    flex: "0 0 auto",
    width: "48px",
    height: "27px",
    padding: 0,
    border: "none",
    borderRadius: "999px",
    background: "#e2e8f0",
    cursor: "not-allowed",
    opacity: 0.72,
  },
  toggleKnobOn: {
    position: "absolute",
    top: "4px",
    left: "25px",
    width: "19px",
    height: "19px",
    borderRadius: "50%",
    background: "#ffffff",
    boxShadow: "0 2px 7px rgba(15, 23, 42, 0.23)",
    transition: "left 0.22s ease, transform 0.22s ease",
    transform: "scale(1)",
  },
  toggleKnobOff: {
    position: "absolute",
    top: "4px",
    left: "4px",
    width: "19px",
    height: "19px",
    borderRadius: "50%",
    background: "#ffffff",
    boxShadow: "0 2px 7px rgba(15, 23, 42, 0.18)",
    transition: "left 0.22s ease, transform 0.22s ease",
    transform: "scale(1)",
  },
  toggleKnobDisabled: {
    position: "absolute",
    top: "4px",
    left: "4px",
    width: "19px",
    height: "19px",
    borderRadius: "50%",
    background: "#f8fafc",
    boxShadow: "none",
  },

  btnSearch: {
    background: "linear-gradient(90deg,#007bff,#00c6ff)",
    color: "#fff",
    fontWeight: "600",
    border: "none",
    padding: "11px 20px",
    minHeight: "42px",
    borderRadius: "8px",
    cursor: "pointer",
    transition: "0.3s",
  },
  tableWrapper: {
    background: "rgba(255, 255, 255, 0.97)",
    border: "1px solid rgba(207, 220, 232, 0.8)",
    borderRadius: "12px",
    boxShadow: "0 12px 30px rgba(30, 60, 90, 0.08)",
    overflowX: "auto",
  },
  table: {
    width: "100%",
    minWidth: "980px",
    borderCollapse: "collapse",
    color: "#34495e",
    fontSize: "13px",
  },
  tableHeader: {
    padding: "15px 14px",
    background: "#f1f6fa",
    borderBottom: "1px solid #dce7ef",
    color: "#466176",
    fontSize: "11px",
    fontWeight: "800",
    letterSpacing: "0.7px",
    textAlign: "left",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
  },
  tableCell: {
    padding: "12px 14px",
    borderBottom: "1px solid #edf2f6",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  tableCellNumber: {
    padding: "12px 14px",
    borderBottom: "1px solid #edf2f6",
    color: "#8191a2",
    verticalAlign: "middle",
  },
  tableCellStudent: {
    padding: "12px 14px",
    borderBottom: "1px solid #edf2f6",
    color: "#203b55",
    fontWeight: "700",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  tableCellExam: {
    padding: "12px 14px",
    borderBottom: "1px solid #edf2f6",
    color: "#60758a",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  tableCellAction: {
    padding: "10px 14px",
    borderBottom: "1px solid #edf2f6",
    verticalAlign: "middle",
    whiteSpace: "nowrap",
  },
  photo: {
    width: "40px",
    height: "40px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "2px solid #2f80ed",
    display: "block",
  },
  noData: {
    textAlign: "center",
    color: "#777",
    padding: "48px 20px",
    fontStyle: "italic",
  },
  btnView: {
    background: "linear-gradient(90deg,#28a745,#6dd47e)",
    color: "#fff",
    padding: "6px 12px",
    borderRadius: "6px",
    textDecoration: "none",
    fontWeight: "600",
    border: "none",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "5px",
  },


};
